import { getUserMail, getCompanyId } from "globalutils/fmUtils";

export const handleDeleteScheduling = ({
    deleteScheduling,
    callback,
    request,
    fetchPaginateApi
}) => (id) => {
    deleteScheduling({
        apiId: 'deleteSchedulingAPI',
        callback,
        data: {
            id,
            callbackPayload: {
                apiId: fetchPaginateApi,
                data: { request: { ...request, fleetManagerEmail: getUserMail(), companyId: getCompanyId() } },
            }
        }
    });
};

export const handleEditScheduling = ({
    editScheduling,
    request,
    fetchPaginateApi
}) => (data) => {
    editScheduling({
        ...data,
        callbackPayload: {
            apiId: fetchPaginateApi,
            data: { request: { ...request, fleetManagerEmail: getUserMail(), companyId: getCompanyId() } },
        }
    });
};
